import { client } from "./index";

// Super Admin: Ownezzy's support team (backend routes/adminSupportAdmins.js)
export const getSupportAdmins = () => client.get("/admin/support-admins");
export const createSupportAdmin = (payload) => client.post("/admin/support-admins", payload);
export const updateSupportAdmin = (id, payload) => client.put(`/admin/support-admins/${id}`, payload);
export const deleteSupportAdmin = (id) => client.delete(`/admin/support-admins/${id}`);
